import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUser, changePassword } from '../../lib/user';

export const fetchUser = createAsyncThunk(
  'auth/fetchUser',
  async (_, { dispatch }) => {
    const user = await getUser();

    return user;
  }
);

export const resetPassword = createAsyncThunk(
  'user/changePassword',
  async ({ userId, body }) => {
    const data = await changePassword(userId, body);
    return data;
  }
)
